module.exports = __webpack_public_path__ + "img/rightArrow.797f42ff.svg";